module.exports = __webpack_public_path__ + "static/logo-nyt-4cff5ca7b55a73f1e2f8d5fcbb777b49.svg";